import { createReducer, on } from '@ngrx/store';
import { changeMarket } from './select-market.action';

export interface MarketOptionState{
  market: string | null;
}

export const initialMarketOptionState: MarketOptionState = {
  market: null
}

export const marketOptionReducer = createReducer(
  initialMarketOptionState,
  on(changeMarket, (state, {market}) => ({...state, market}))
  )